import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class PromoService extends BaseService {
  getPromo(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get("promotion/v3/promotionv3").subscribe(
      (resp) => {
        onSuccess(resp.data);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getPromoDetail(
    param: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`promotion/v3/${param}`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getPromoHome(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`promotion/v3/promotionv3`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
    // promotion path origin promotion/v3/promotionv3?offset=0&limit=10
  }
}
